import Button from '../buttons/button'
import {
	TypographyHeading,
	TypographyLabel,
	TypographyParagraph,
} from '../typography'
import { CopyIcon, OpenInNewIcon } from '../icons'
import { Tooltip, TooltipRefProps } from 'react-tooltip'
import Image from '../content/Image'
import { useRef } from 'react'

export default function TweetPreview({ tweet }: { tweet: any }) {
	const tooltipCopyIPFS = useRef<TooltipRefProps>(null)
	const tooltipCopyArweave = useRef<TooltipRefProps>(null)

	return (
		<div className="flex flex-col gap-y-4">
			<div className="flex flex-col rounded bg-uiTertiaryLight p-4 dark:bg-uiTertiaryDark">
				<div className="flex flex-row items-center justify-between">
					<TypographyHeading
						size="small"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						Preview
					</TypographyHeading>
					<div className="flex flex-row gap-x-2">
						<a href={tweet.ipfsURL} target="_blank">
							<Button variant="secondary" leftIcon={<OpenInNewIcon />}>
								View in IPFS
							</Button>
						</a>
						<a href={tweet.arweaveURL} target="_blank">
							<Button variant="primary" leftIcon={<OpenInNewIcon />}>
								View in Arweave
							</Button>
						</a>
					</div>
				</div>
				<div className="mt-4 flex flex-row items-center gap-x-2">
					<TypographyLabel
						size="medium"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						Arweave Transaction:
					</TypographyLabel>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.arweaveCID}
					</TypographyParagraph>
					<div id="copyArweave" className="flex flex-row">
						<CopyIcon
							className="h-4 w-4 text-textSecondaryLight hover:cursor-pointer dark:text-textSecondaryDark"
							onClick={() => {
								navigator.clipboard.writeText(tweet.arweaveCID)
								tooltipCopyArweave.current?.open({
									anchorSelect: '#copyArweave',
									content: 'Copied!',
								})
								setTimeout(() => {
									tooltipCopyArweave.current?.close()
								}, 2000)
							}}
						/>
						<Tooltip imperativeModeOnly ref={tooltipCopyArweave} />
					</div>
				</div>
				<div className="mt-2 flex flex-row items-center gap-x-2">
					<TypographyLabel
						size="medium"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						IPFS CID:
					</TypographyLabel>
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{tweet.ipfsCID}
					</TypographyParagraph>
					<div id="copyIPFS" className="flex flex-row">
						<CopyIcon
							className="h-4 w-4 text-textSecondaryLight hover:cursor-pointer dark:text-textSecondaryDark"
							onClick={() => {
								navigator.clipboard.writeText(tweet.ipfsCID)
								tooltipCopyIPFS.current?.open({
									anchorSelect: '#copyIPFS',
									content: 'Copied!',
								})
								setTimeout(() => {
									tooltipCopyIPFS.current?.close()
								}, 2000)
							}}
						/>
						<Tooltip imperativeModeOnly ref={tooltipCopyIPFS} />
					</div>
				</div>
				<Image
					className="mt-6 h-auto w-4/5"
					imageUrl={tweet.image}
					imageAlt={tweet.image}
				></Image>
			</div>
		</div>
	)
}
